import { Component, OnInit, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ReportingService } from '../services/reporting.service';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver/FileSaver';
declare var $ : any;

@Component({
  selector: 'app-testreportlist',
  templateUrl: './testreportlist.component.html',
  styleUrls: ['./testreportlist.component.css']
})

export class TestReportListComponent implements OnInit {
  headerText = "this is bob text";
  caller = "none";
  displaySymbolModal = "none";
  orders = [];
  p: number = 1;
  nDays = 90; // Change this to 30 eventually, but use 90 for now since we have no newer tests
  patientId = -1;
  public column = "reportDate";
  public isDesc = false;

  constructor(private reportService: ReportingService, private route: ActivatedRoute) 
  {
    this.displaySymbolModal='none';
  }

  ngOnInit() {
    this.route.queryParams
      // .filter(params => params.order)
      .subscribe(params =>
      {
        this.caller = params.caller;
      });

    // Populate table with most recent test order list
    if (sessionStorage.getItem('myTestOrders'))
      this.orders = JSON.parse(sessionStorage.getItem('myTestOrders'));

    switch(this.caller)
    {
      case "mypatients" :
        this.headerText = "These are all your test orders for the patient you selected";
        break;
      case "ordersearch":
        this.headerText = "These are your test orders for the selected sample dates and test";
        break;
      default:
        if (this.orders.length == 0)
          this.getTestReportList();
        this.headerText=`These are your recent test orders (last ${this.nDays} days)`;
        break;
    }
  }

  showReport(orderTestId, orderEntityId)
  {
    console.log(`ShowRport for OrderTestId ${orderTestId}, OrderEntityId ${orderEntityId}.`);
    this.reportService.getReport(orderTestId, orderEntityId).subscribe(
      (data : any)=>{
        let url = window.URL.createObjectURL(data);
        // let fileName = url.substring(url.lastIndexOf('/')+1)+".pdf";
        window.URL.revokeObjectURL(url);
        var blob = new Blob([data], {type: 'application/pdf'});
        saveAs(blob, "TestReport.pdf");
      },
      (err : HttpErrorResponse)=>{
        console.log(err);
      }
    );
  }

  showSymbolsModal()
  {
    this.displaySymbolModal = 'block';
  
    $('.modal-dialog').draggable({
      handle: ".modalHeader"
    });

    this.centerModal();
  }
  
  onResize(event) {
    this.centerModal();
  }

  centerModal()
  {
    $('.modal-dialog')[0].style.top = "0px";
    if (window.innerWidth < 500)
    {
      $('.modal-dialog')[0].style.left = 0;
    }
    else
    {
      $('.modal-dialog')[0].style.left = ((window.innerWidth - 375) / 2) + "px";
    }
  }
  hideSymbolsModal()
  {
    this.displaySymbolModal = 'none';
  }

  @HostListener('document:keyup', ['$event']) handleKeyUp(event) {
    if (event.keyCode === 27) {
        this.hideSymbolsModal();
    }
  }

  getTestReportList(){
    this.reportService.getRecentTestOrders(this.nDays).subscribe(
      (data : any)=>{
        sessionStorage.setItem('myTestOrders', JSON.stringify(data));
        this.orders = data;
      },
      (err : HttpErrorResponse)=>{
        console.log(err);
      }
    );
  }

  sort(property){
    if (this.column == property)
      this.isDesc = !this.isDesc; //change the direction only if changing the same field
    else
      this.isDesc = false;
    
    this.column = property;
    let direction = this.isDesc ? -1 : 1;

    this.orders.sort(function(a, b){
        if(a[property] < b[property]){
            return -1 * direction;
        }
        else if( a[property] > b[property]){
            return 1 * direction;
        }
        else{
            return 0;
        }
    });
  };
}